import React, { useState, useEffect } from 'react';

import './CookieConsent.scss';

const CONSENT_KEY = 'cookie_consent';
const GA_MEASUREMENT_ID = 'G-0EBDWQQKS1';

// Dynamically injects the GA4 script tags — only ever called after
// the user has actively clicked Accept, never on page load by default.
const loadGoogleAnalytics = () => {
    if (document.getElementById('ga-script')) return; // avoid loading twice

    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
};

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(CONSENT_KEY);

        if (stored === 'accepted') {
            loadGoogleAnalytics();
        } else if (stored !== 'declined') {
            // No prior choice recorded — show the banner
            setVisible(true);
        }
        // If stored === 'declined', do nothing: banner stays hidden, GA never loads
    }, []);

    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted');
        loadGoogleAnalytics();
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(CONSENT_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className='cookie-consent-banner'>
            <p className='cookie-consent-text'>
                This site uses cookies to analyze traffic. You can accept or decline analytics cookies.{' '}
                <a href='/privacy-policy' className='cookie-consent-link'>Privacy Policy</a>
            </p>
            <div className='cookie-consent-actions'>
                <button className='cookie-consent-decline' onClick={handleDecline}>Decline</button>
                <button className='cookie-consent-accept' onClick={handleAccept}>Accept</button>
            </div>
        </div>
    );
};

export default CookieConsent;
